var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-modal",class:_vm.classes},[_c('div',{staticClass:"uk-modal-dialog"},[(_vm.opened)?[_vm._t("default")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }